import UserService from './UserService';
import { getJson, postJson, putJson } from './ServiceHelperMethods';

const qs = (params) => {
    const entries = Object.entries(params).filter(([, v]) => v !== undefined && v !== null && v !== '');
    if (!entries.length) return '';
    return '?' + entries.map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`).join('&');
};

class ImageLabelService {
    static async list({ modelId, status, classLabel, limit, skip }) {
        return getJson(`imagelabels${qs({ model: modelId, status, classLabel, limit, skip })}`);
    }

    static async update(id, body) {
        return putJson(`imagelabels/${id}`, body);
    }

    static async batch({ ids, action }) {
        return postJson('imagelabels/batch', { ids, action });
    }

    static async create(docs) {
        return postJson('imagelabels', docs);
    }

    // Uploads image files to the server-side optimization pipeline.
    // Returns { count, savedBytes, savedPercent, originalBytes, processedBytes, items }.
    static async upload(files, { modelId, classLabel = '' }) {
        const form = new FormData();
        for (const file of files) form.append('files', file);

        const headers = await UserService.getUserHeader();
        const response = await fetch(
            `${process.env.REACT_APP_PUBLIC_API_URL}/imagelabels/upload${qs({ model: modelId, classLabel })}`,
            { method: 'POST', headers, body: form },
        );
        if (!response.ok) {
            const text = await response.text().catch(() => response.statusText);
            let msg;
            try { msg = JSON.parse(text)?.error; } catch { msg = null; }
            throw new Error(msg || text || `Upload failed (${response.status})`);
        }
        return response.json();
    }
}

export default ImageLabelService;
